module.exports = __webpack_public_path__ + "img/icon-volume-close.f6209c77.png";